const draftCarePlan = (memberId, planId) => {
  window.open(`${memberId}/care_plans/${planId}/edit`);
  return true;
};

export default draftCarePlan;
